<div class="text-center">
	<p>
		Do pokoju zostanie doliczona dopłata:
		{{ additionalRoomSizeCharge | price }} PLN<br />Czy chcesz kontynuować?
	</p>
	<button [mat-dialog-close]="true" mat-raised-button color="primary" type="submit" class="me-1">Tak</button>
	<button [mat-dialog-close]="false" mat-raised-button color="warn" class="ms-1">Nie</button>
</div>
